import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useLanguageAPI() {
  const { menuIdRef, languageRef } = useStorage();

  function findLanguagesFromRemote() {
    const url = `/vbeta2/menu/languages`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    findLanguagesFromRemote,
  };
}

export { useLanguageAPI };
